<script>
import vue2Dropzone from "vue2-dropzone";
import axios from "axios";
import {env} from "@/state/helpers";
import VueEasyLightbox from "vue-easy-lightbox";
import Swal from "sweetalert2";


/**
 * Form Layouts component
 */
export default {
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
  page: {
    title: "Campaign",
  },
  components: {vueDropzone: vue2Dropzone, VueEasyLightbox},
  methods: {
    fileUploaded(file, response) {
      this.$refs.myVueDropzone.removeFile(file)
      this.$store.commit('campaign/UPDATE_CAMPAIGN', response);
    },
    async removeAttachment(attachment) {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#868585",
        confirmButtonText: "Yes!"
      })

      if (!result.value) {
        return;
      }

      try {
        const response = await axios.delete(`/client/campaign/${this.campaign._id}/attachment/${attachment._id}`)
        this.$store.commit('campaign/UPDATE_CAMPAIGN', response.data);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
      }

    },
    checkMimeType(mimeType, target) {
      if (typeof mimeType !== 'string' && !(mimeType instanceof String)) {
        return false
      }

      return mimeType.includes(target);
    },
    previewAttachment(attachment) {
      if (this.checkMimeType(attachment.mime_type, 'image')) {
        this.showLightbox = true;
        this.modalImageURL = attachment.url;
      } else {
        window.open(attachment.url, '_blank');
      }
    },
    closeLightbox() {
      this.showLightbox = false;
      this.modalImageURL = '';
    },
    async addLink() {
      try {
        const response = await axios.post(`/client/campaign/${this.campaign._id}/link`, {
          name: this.newLinkName,
          url: this.newLinkUrl,
        })

        this.$store.commit('campaign/UPDATE_CAMPAIGN', response.data);

        this.newLinkName = '';
        this.newLinkUrl = '';
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
      }
    },
    async removeLink(linkId) {
      try {
        const response = await axios.delete(`/client/campaign/${this.campaign._id}/link/${linkId}`)
        this.$store.commit('campaign/UPDATE_CAMPAIGN', response.data);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
      }

    }
  },
  computed: {

  },
  data() {
    // See: https://www.npmjs.com/package/vue2-dropzone/v/2.3.6?activeTab=readme
    return {
      showLightbox: false,
      modalImageURL: '',
      dropzoneOptions: {
        url: env('VUE_APP_API_URL') + `/client/campaign/${this.campaign._id}/attachment`,
        paramName: "attachment",
        thumbnailWidth: 150,
        maxFilesize: 100,
        withCredentials: true,
        acceptedFiles: 'image/*,application/pdf',
      },
      newLinkName: '',
      newLinkUrl: '',
    }
  }
};
</script>

<template>
  <div>
    <div class="row pt-3">
      <div class="col-12">

        <p class="font-size-13 mt-2 mb-3">
          Here you can add attachments that will better describe your campaign. These attachments will inspire our Influencers to create the best posts for your campaign.
        </p>

        <h4 class="card-title mt-2 mb-3">Links</h4>

        <div class="row">
          <div class="col-12">
            <form @submit.prevent="removeLink(link._id)" class="form-inline mb-2" v-for="(link, index) in campaign.links" :key="index">
              <div class="form-group">
                <label class="font-weight-normal mr-2" style="min-width: 10px">{{index + 1}}.</label>
                <label class="font-weight-normal">Name</label>
                <input disabled v-model="link.name" type="text" class="form-control mx-sm-3 not-allowed" placeholder="Enter link name" required>

                <label class="font-weight-normal">URL</label>
                <input disabled v-model="link.url" type="url" class="form-control mx-sm-3 not-allowed" placeholder="Enter link URL" required>

                <button class="btn btn-outline-danger btn-sm" type="submit">
                  <i class="far fa-times-circle"></i>
                  Remove
                </button>

              </div>
            </form>

            <form v-can.disabled-otherwise="'client'" @submit.prevent="addLink()" class="form-inline mb-2">
              <div class="form-group">
                <label class="font-weight-normal mr-2" style="min-width: 10px">{{campaign.links ? campaign.links.length + 1 : 1}}.</label>
                <label class="font-weight-normal">Name</label>
                <input v-model="newLinkName" type="text" class="form-control mx-sm-3" placeholder="Google" required>

                <label class="font-weight-normal">URL</label>
                <input v-model="newLinkUrl" type="url" class="form-control mx-sm-3" placeholder="https://google.com" required>

                <button v-can.remove-otherwise="'client'" class="btn btn-outline-primary btn-sm" type="submit">
                  <i class="fas fa-plus"></i>
                  Add link
                </button>
              </div>
            </form>
          </div>
        </div>

        <h4 class="card-title mb-4 mt-4">Files</h4>

        <div class="row">
          <div class="col-12 d-flex flex-wrap justify-content-center">
            <div v-for="(attachment, index) in campaign.attachments" :key="index" class="mb-3 mr-3">
              <div class="text-white position-relative">

                <a class="close-icon text-danger" @click="removeAttachment(attachment)">
                  <i class="fas fa-times-circle" v-b-tooltip.hover.right title="Remove"></i>
                </a>

                <div @click="previewAttachment(attachment)" class="attachment has-pointer-cursor" v-b-tooltip.hover :title="attachment.name">
                  <img v-if="checkMimeType(attachment.mime_type, 'image')" :src="attachment.url" class="img-fluid" alt="">
                  <i v-else-if="checkMimeType(attachment.mime_type, 'pdf')" class="fas fa-file-pdf attachment"></i>
                  <i v-else-if="checkMimeType(attachment.mime_type, 'zip') || checkMimeType(attachment.mime_type, 'rar')" class="fas fa-file-archive attachment"></i>
                  <i v-else class="fas fa-file-download attachment"></i>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div v-can.remove-otherwise="'client'" class="row">
          <div class="offset-2 col-8">
            <p class="card-title-desc text-center mb-3 mt-2">Upload images or documents you would like to share with potential influencers.</p>
            <!-- file upload -->
            <vue-dropzone
                id="dropzone"
                ref="myVueDropzone"
                :use-custom-slot="true"
                :options="dropzoneOptions"
                v-on:vdropzone-success="fileUploaded"
            >
              <div class="dropzone-custom-content">
                <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                <h4>Drop files here or click to upload.</h4>
              </div>
            </vue-dropzone>
          </div>
          <!-- end col -->
        </div>

      </div>
    </div>

    <vue-easy-lightbox
        :visible="showLightbox"
        :imgs="modalImageURL"
        @hide="closeLightbox"
    ></vue-easy-lightbox>
  </div>
</template>

<style scoped>

.attachment {
  position: relative;
  height: 120px;
  width: 160px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #dce7f1;
  font-size: 90px;
}

.attachment img {
  max-height: 120px;
}

.close-icon {
  cursor: pointer;
  position: absolute;
  top: -8px;
  right: -8px;
  font-size: 16px;
  z-index: 99;
}
</style>
